// One totals bar for every finance list (finance-real round 3): To do's groups, Cash's movements, Clients', Team's and
// Business expenses' tables. It goes in a DataTable's or a WorkspacePanel's footer slot, so it
// sits at the bottom of the list, never in its header. Each figure is the server's (TD-102). A note hides on a phone so the
// bar stays one row.
import { MoneyText } from "@/components/ui/MoneyText";

export interface TotalItem {
  label: string;
  amountMinor: number;
  note?: string;
}

export function TotalsFooter({ items }: { items: TotalItem[] }) {
  return (
    <div role="group" aria-label="Totals" className="flex flex-wrap items-center justify-end gap-x-6 gap-y-1 bg-gray-50 px-4 py-3 text-sm">
      {items.map((item) => (
        <span key={item.label} className="text-gray-500">
          {`${item.label} `}
          <MoneyText amountMinor={item.amountMinor} strong />
          {item.note && <span className="hidden sm:inline text-xs text-gray-400">{` · ${item.note}`}</span>}
        </span>
      ))}
    </div>
  );
}
